export default __webpack_public_path__ + "static/media/093-down-arrow.e2525c0c.png";